import React from 'react';
import SpecialityForm from '../shared/speciality-form';
import globalStyles from '../../utility/styles';

const style = {
  box: {
    marginLeft: '20%',
    marginRight: '20%'
  }
};


const SpecialityCreationPage = (props) => {
  return (
    <div>
      <h1 style={globalStyles.header}>Create Speciality</h1>
      <div style={style.box}>
        <SpecialityForm {...props}/>
      </div>
    </div>
  )
}

export default SpecialityCreationPage;


// WEBPACK FOOTER //
// ./src/screens/create-speciality/index.js